import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import principle03 from "./layouts/principle-03/principle";
import principle04 from "./layouts/principle-04/principle";
import principle05 from "./layouts/principle-05/principle";
import principle06 from "./layouts/principle-06/principle";

const lesson: Lesson = {
  id: "76abb179-85ae-480b-9eeb-2a7beac132e9",
  publicId: "31",
  name: "Two-port characterization",
  difficulty: 2,
  showHeaderNavigation: true,
  body: [principle01, principle02, principle03, principle04, principle05, principle06],
};

export default lesson;
